//.MUI Datagrid row selection handler function for bulk approval table
export function onBulkApprovalRowSelectionHandler(
  ids,
  itemList,
  setSelectedRowsData,
  setSelectedRowsSummaryData
) {
  if (ids) {
    let selectedRows = [];
    let selectedRowsSummary = [];

    ids.map((id) =>
      itemList.find(
        (row) =>
          row.qualityReportsID === id &&
          (selectedRows.push({
            sampleRequestID: row.sampleRequestID,
            qualityReportsID: row.qualityReportsID,
            sampleItemID: row.sampleItemID,
            itemDescription: row.itemDescription,
            requesterEmail: row.requesterEmail,
            executiveChefEmail: row.executiveChefEmail,
            HODDepartment: row.HODDepartment,
            organization: row.organization ? row.organization : "N/A",
          }),
          selectedRowsSummary.push(row))
      )
    );
    setSelectedRowsData(selectedRows);
    setSelectedRowsSummaryData(selectedRowsSummary);
  }
}
